"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var QueriesStore_1 = require("stores/QueriesStore");
var PriceQueryStage2_1 = __importDefault(require("./PriceQueryStage2"));
var FleetQueryStage2_1 = __importDefault(require("./FleetQueryStage2"));
var PODQueryStage2_1 = __importDefault(require("./PODQueryStage2"));
var QueryDetailsStage2 = function (_a) {
    var data = _a.data;
    return (react_1.default.createElement("div", { className: "query-stage query-stage-2" },
        react_1.default.createElement("div", { className: "title" }, "Stage 2"),
        data.queryType.id === QueriesStore_1.QueryTypes.PRICE &&
            react_1.default.createElement(PriceQueryStage2_1.default, { data: data }),
        data.queryType.id === QueriesStore_1.QueryTypes.FLEET &&
            react_1.default.createElement(FleetQueryStage2_1.default, { data: data }),
        data.queryType.id === QueriesStore_1.QueryTypes.POD &&
            react_1.default.createElement(PODQueryStage2_1.default, { data: data })));
};
exports.default = QueryDetailsStage2;
